import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";
import ResponsiveStyleSheet from "react-native-media-query";
export const { styles, ids } = ResponsiveStyleSheet.create({
  panel: createResponsiveStyles({
    base: {
      flexDirection: "row",
      flexWrap: "wrap",
      paddingVertical: theme.spacing.small,
    },
    medium: {
      paddingVertical: theme.spacing.medium,
      justifyContent: "space-between",
      alignItems: "center",
    },
  }),
  headingWrap: createResponsiveStyles({
    medium: { flex: 1 },
  }),
  subheading: {
    textTransform: "uppercase",
    marginBottom: theme.spacing.xsmall2,
  },
  serviceImages: createResponsiveStyles({
    base: {
      width: "100%",
      flexDirection: "row",
      justifyContent: "space-between",
      paddingTop: theme.spacing.small,
      paddingRight: theme.spacing.xlarge,
      marginBottom: -theme.spacing.xsmall2,
    },
    medium: {
      flex: 2,
      marginBottom: 0,
      padding: 0,
      marginHorizontal: theme.spacing.xlarge2,
    },
  }),
  imageContainer: {
    width: theme.spacing.xlarge,
    height: theme.spacing.xlarge,
  },
  image: {
    width: "100%",
    height: "100%",
  },
});
